module.exports = __webpack_public_path__ + "img/back9.ef57d3c3.png";